export default __webpack_public_path__ + "static/media/98-17_header_invoice.0aba9461.png";